/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Samantha_LumbyInputs */

const en_testimonial_samantha_lumby = /** @type {(inputs: Testimonial_Samantha_LumbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutely brilliant, haven't been able to find an app that can say scientific words properly until now. Very easy to use.`)
};

const es_testimonial_samantha_lumby = /** @type {(inputs: Testimonial_Samantha_LumbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutamente brillante, no había podido encontrar una app que pronuncie correctamente las palabras científicas hasta ahora. Muy fácil de usar.`)
};

/**
* | output |
* | --- |
* | "Absolutely brilliant, haven't been able to find an app that can say scientific words properly until now. Very easy to use." |
*
* @param {Testimonial_Samantha_LumbyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_samantha_lumby = /** @type {((inputs?: Testimonial_Samantha_LumbyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Samantha_LumbyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_samantha_lumby(inputs)
	return en_testimonial_samantha_lumby(inputs)
});